/* eslint-disable prettier/prettier */
/* eslint-disable */

import React, { useContext } from 'react';
import classNames from 'classnames';

import { PdfPortfolioTitlePage, PdfPortfolioPersonalInfo } from '../../components/pdfStudent';
import { PdfPerformanceContainer, PdfPerformanceContainerOld } from '../../containers/pdfStudent';

import { ISectionsVisibility } from '../../api/types';
import {
  PdfAdditionalEducationContainer,
  PdfCivilClubContainer,
  PdfCivilContestContainer,
  PdfCivilSectionContainer,
  PdfCreativeCircleContainer,
  PdfCreativeContestContainer,
  PdfCreativeSectionContainer,
  PdfCultureVisiting,
  PdfDocumentsContainer,
  PdfGiaWorldskillsContainer,
  PdfInterestsContainer,
  PdfJobsContainer,
  PdfMetaskillsContainer,
  PdfOlympiadContainer,
  PdfOnlineVisiting,
  PdfPracticeContainer,
  PdfProfessionEventsContainer,
  PdfProforientationRecommendations,
  PdfProforientationEvents,
  PdfScienceContestContainer,
  PdfScienceOccupationContainer,
  PdfScienceProjectContainer,
  PdfSportClubContainer,
  PdfSportCompetitionContainer,
  PdfSportExpeditionContainer,
  PdfSportSectionContainer,
  PdfTrainingContainer,
  PdfApplications,
  PdfProforientation,
} from '../../containers/pdfStudent/dataEntityContainers';
import PdfGia from '../../components/pdfStudent/PdfGia';
import PdfTrialExam from '../../components/pdfStudent/PdfTrialExam';
import PdfDiagnostics from '../../components/pdfStudent/PdfDiagnostics';
import PdfEducationSection from '../../containers/pdfStudent/eductionSectionContainer';
import {
  pdfSectionCivil,
  pdfSectionCreation,
  pdfSectionCulture,
  pdfSectionProfession,
  pdfSectionProfile,
  pdfSectionScience,
  pdfSectionSport,
  pdfSectionStudy,
} from '../../icons';
import {
  PdfCivilRewardContainer,
  PdfCreationRewardContainer,
  PdfProfessionRewardContainer,
  PdfScienceRewardContainer,
  PdfSportRewardContainer,
} from '../../containers/pdfStudent/rewardContainers';
import { useAppSelector } from 'hooks';
import { activeFormatSelector } from 'selectors/drawers';
import { configSelector } from 'selectors';

import './index.scss';

interface IStudentPortfolioPdfProps {
  display: ISectionsVisibility;
}

const StudentPortfolioPdf: React.FC<IStudentPortfolioPdfProps> = ({ display }) => {
  const format = useAppSelector(activeFormatSelector);
  const config = useAppSelector(configSelector);

  const studyPerformanceContainer = config?.OLD_PERFORMANCE_WIDGET ? (
    <PdfPerformanceContainerOld />
  ) : (
    <PdfPerformanceContainer />
  );
  const showCulture = config && config.HIDE_CULTURE !== true;

  const showProforientation = config && config.HIDE_PROFESSION_PROFORIENTATION !== true;
  const showApplications = config && config.HIDE_PROFESSION_APPLICATIONS !== true;
  const showProforientationRecommendations = config && config.HIDE_PROFESSION_RECOMMENDATIONS !== true;
  const showProforientationEvents = config && config.HIDE_PROFESSION_EVENTS !== true;
  const showAdditionalEducation = config && config.HIDE_PROFESSION_EDUCATION !== true;

  return (
    <>
      <div
        className={classNames('student-portfolio-pdf', {
          'student-portfolio-pdf--horizontal': format === 'horizontal',
        })}
      >
        <PdfPortfolioTitlePage isStudentInfoShown={display.studentData} />
        <div className="student-portfolio-pdf__container">
          {display.studentData && <PdfPortfolioPersonalInfo />}
          {display.studies && (
            <PdfEducationSection title="Учёба" icon={pdfSectionStudy}>
              {display.trainingInfo && <PdfTrainingContainer />}
              {display.practice && <PdfPracticeContainer />}
              {display.documents && <PdfDocumentsContainer />}
              {display.performance && studyPerformanceContainer}
              {display.gia && <PdfGia displaySettings={display} />}
              {display.diagnostic && <PdfDiagnostics displaySettings={display} />}
              {display.olympiads && <PdfOlympiadContainer />}
              {display.trialExam && <PdfTrialExam />}
            </PdfEducationSection>
          )}
          {display.science && (
            <PdfEducationSection title="Наука" icon={pdfSectionScience}>
              {display.scienceReward && <PdfScienceRewardContainer />}
              {display.projects && <PdfScienceProjectContainer />}
              {display.scienceEmployments && <PdfScienceOccupationContainer />}
              {display.scienceContest && <PdfScienceContestContainer />}
            </PdfEducationSection>
          )}
          {display.sport && (
            <PdfEducationSection title="Cпорт" icon={pdfSectionSport}>
              {display.sportReward && <PdfSportRewardContainer />}
              {display.sportClub && <PdfSportClubContainer />}
              {display.sportUnit && <PdfSportSectionContainer />}
              {display.sportGames && <PdfSportCompetitionContainer />}
              {display.hike && <PdfSportExpeditionContainer />}
            </PdfEducationSection>
          )}
          {display.creation && (
            <PdfEducationSection title="Творчество" icon={pdfSectionCreation}>
              {display.creationReward && <PdfCreationRewardContainer />}
              {display.creationClub && <PdfCreativeCircleContainer />}
              {display.creationContest && <PdfCreativeContestContainer />}
              {display.creationUnit && <PdfCreativeSectionContainer />}
            </PdfEducationSection>
          )}
          {display.culture && showCulture && (
            <PdfEducationSection title="Культура" icon={pdfSectionCulture}>
              {display.offlineVisit && <PdfCultureVisiting />}
              {display.onlineVisit && <PdfOnlineVisiting />}
            </PdfEducationSection>
          )}
          {display.civil && (
            <PdfEducationSection title="Гражданская активность" icon={pdfSectionCivil}>
              {display.civilReward && <PdfCivilRewardContainer />}
              {display.civilClub && <PdfCivilClubContainer />}
              {display.civilContest && <PdfCivilContestContainer />}
              {display.civilUnit && <PdfCivilSectionContainer />}
            </PdfEducationSection>
          )}
          {display.profession && (
            <PdfEducationSection title="Моя профессия" icon={pdfSectionProfession}>
              {display.professionCareerGuidance && showProforientation && <PdfProforientation />}
              {display.professionApplications && showApplications && <PdfApplications />}
              {display.professionRecommendations && showProforientationRecommendations && (
                <PdfProforientationRecommendations />
              )}
              {display.professionProfEvents && showProforientationEvents && <PdfProforientationEvents />}
              {display.professionRewards && <PdfProfessionRewardContainer />}
              {display.job && <PdfJobsContainer />}
              {display.metaskills && <PdfMetaskillsContainer />}
              {display.professionEducation && showAdditionalEducation && <PdfAdditionalEducationContainer />}
              {display.professionEvents && <PdfProfessionEventsContainer />}
              {display.professionWorldskills && <PdfGiaWorldskillsContainer />}
            </PdfEducationSection>
          )}
          {display.profile && (
            <PdfEducationSection title="Обо мне" icon={pdfSectionProfile}>
              {display.interests && <PdfInterestsContainer />}
            </PdfEducationSection>
          )}
        </div>
      </div>
    </>
  );
};

export default StudentPortfolioPdf;
